// extracted by mini-css-extract-plugin
module.exports = {"requestMessageTagWrapper":"styles_requestMessageTagWrapper__lxB4R","requestMessageTagRow":"styles_requestMessageTagRow__2mEye"};